import { videoData } from "../data/mock";
import { Play, MonitorPlay } from "lucide-react";

export const VideoSection = () => {
  return (
    <section
      id="video"
      className="relative py-24"
      style={{ background: "#1a1c1b" }}
    >
      <div className="absolute top-0 left-0 right-0 h-px bg-[#3f4816]/30" />

      <div className="max-w-[87.5rem] mx-auto px-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Section Header */}
          <span
            className="inline-block text-[#888680] text-xs font-medium uppercase tracking-[0.2em] mb-5"
            style={{ fontFamily: "'Inter', Arial, sans-serif" }}
          >
            Explainer
          </span>
          <h2
            className="font-black uppercase leading-[0.88] mb-4"
            style={{
              fontFamily: "'Inter', Arial, sans-serif",
              fontSize: "clamp(1.6rem, 1.2rem + 2vw, 2.8rem)",
              letterSpacing: "-0.02em",
            }}
          >
            <span className="text-[#dfddd6]">See </span>
            <span className="text-[#d9fb06]">how it works</span>
          </h2>
          <p
            className="text-[#888680] text-sm leading-relaxed mb-12 max-w-lg mx-auto"
            style={{ fontFamily: "'Inter', Arial, sans-serif" }}
          >
            {videoData.subtitle}
          </p>

          {/* Video Placeholder */}
          <div className="relative aspect-video bg-[#302f2c]/50 border border-[#3f4816]/20 rounded-sm overflow-hidden group cursor-pointer">
            {videoData.videoUrl ? (
              <iframe
                src={videoData.videoUrl}
                title="Explainer Video"
                className="w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            ) : (
              /* Placeholder when no video URL */
              <div className="absolute inset-0 flex flex-col items-center justify-center">
                <div className="w-20 h-20 rounded-full bg-[#d9fb06]/10 border border-[#d9fb06]/30 flex items-center justify-center mb-5 group-hover:bg-[#d9fb06]/15 transition-colors duration-300">
                  <Play size={28} className="text-[#d9fb06] ml-1" />
                </div>
                <div className="flex items-center gap-2 text-[#888680] text-sm">
                  <MonitorPlay size={16} className="text-[#3f4816]" />
                  <span style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
                    Video coming soon
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
